import { Button } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';

export type GenerateDescriptionButtonLabels = {
  label?: string;
  tooltip?: string;
};

export type GenerateDescriptionProps = {
  onClick: VoidFunction | (() => Promise<void>);
  isLoading: boolean;
  hasError: boolean;
  isMissingItemToDescribe?: boolean;
  label?: string;
  isDisabled?: boolean;
  infoTooltip?: string;
  missingItemTooltip?: string;
};

export const getGenerateDescriptionDataTooltipText = (
  isMissingItemToDescribe?: boolean,
  missingItemTooltip = 'Please provide a name to enable the AI to generate a description'
) => {
  if (isMissingItemToDescribe) {
    return missingItemTooltip;
  }
  return undefined;
};

type GenerateDescriptionButtonProps = {
  isDisabled?: boolean;
} & GenerateDescriptionProps;

export const GenerateDescriptionButton = ({
  isDisabled,
  ...props
}: GenerateDescriptionButtonProps) => {
  const {
    isLoading,
    isMissingItemToDescribe,
    onClick: handleClick,
    hasError,
    label,
    infoTooltip,
    missingItemTooltip,
  } = props;

  return (
    <Button
      isDisabled={isDisabled}
      onClick={() => {
        if (isMissingItemToDescribe || isLoading) {
          return;
        }
        handleClick();
      }}
      hasError={hasError}
      data-tooltip-text={
        getGenerateDescriptionDataTooltipText(
          isMissingItemToDescribe,
          missingItemTooltip
        ) || infoTooltip
      }
    >
      <Icon
        iconName={isLoading ? IconName.SPINNER : IconName.SPARKLES}
        style={{ color: colors.brand600 }}
      />
      {isLoading ? '' : label || 'Generate description'}
    </Button>
  );
};
